import axiosInstance from "../interceptor/instance";
import axiosMapInstance from "../interceptor/webMapInstance";

const baseUrl = `${process.env.REACT_APP_BASE_URL_WEB_MAP}/market-share`;

export const getTopMarketShareData = async (data, perPage, page = 1, cancelToken) => {
  const response = await axiosMapInstance.get(
    `${baseUrl}/top/${data.country}/${data.borderLvl}?quarter=${data.quarter}&connectionType=${data.connectionType}${data.aggType ? "&aggType="+data.aggType : ""}&limit=${perPage}&page=${page}`,
    {
      params: {
        adminLevel1 : data.adminLevel1,
        adminLevel2: data.adminLevel2,
        adminLevel3: data.adminLevel3
      },
      cancelToken: cancelToken.token,
    }
  );
  return response.data;
};

export const getOperatorMarketShareTableData = async (
  data,
  perPage,
  page = 1
) => {
  const response = await axiosMapInstance.get(
    `${baseUrl}/operator/divisional/${data.country}/${data.borderLvl}?quarter=${data.quarter}&connectionType=${data.connectionType}&limit=${perPage}&page=${page}&msRangeFrom=${data.msRangeFrom}&msRangeTo=${data.msRangeTo}&operator=${data.operator}`,
    {
      params: {
        adminLevel1: data.adminLevel1,
        adminLevel2: data.adminLevel2,
        adminLevel3: data.adminLevel3,
        action: data.action,
        quad: data.quad,
        msRank: data.rank,
        sortBy: data.sortBy || "adm1", 
        sortOrder: data.sortOrder || "asc"
      },
    }
  );
  return response.data;
};

export const getOprtMarketShareData = async (data, perPage, page = 1, cancelToken) => {
  const response = await axiosMapInstance.get(
    `${baseUrl}/operator/heat-map/${data.country}/${data.borderLvl}`,
    {
      params: {
        adminLevel1 : data.adminLevel1,
        adminLevel2: data.adminLevel2,
        adminLevel3: data.adminLevel3,
        quarter: data.quarter,
        operator: data.operator,
        connectionType: data.connectionType,
        ...(data.aggType? {aggType: data.aggType} : {}),
        msRangeFrom: data.msRangeFrom,
        msRangeTo: data.msRangeTo,
        type: data.type,
        filter: data.filter,
        action: data.action,
        rank: data.ranks,
        quad: data.quad,
        limit: perPage,
        page,
      },
      cancelToken: cancelToken.token,
      hideLoader: true
    }
  );
  return response.data;
};


export const getOperatorNationMarketSharePieData = async (
  data,
) => {
  const response = await axiosMapInstance.get(
    `${baseUrl}/operator/pie-chart/nation/${data.country}?quarter=${data.quarter}&connectionType=${data.connectionType}`,
    { hideLoader: true }
  );
  return response.data;
};


export const getOperatorMarketShareScatterData = async (
  data,
) => {
  const response = await axiosMapInstance.get(
    `${baseUrl}/operator/scatter-chart/${data.country}/${data.borderLvl}?quarter=${data.quarter}&connectionType=${data.connectionType}&msRangeFrom=${data.msRangeFrom}&msRangeTo=${data.msRangeTo}&operator=${data.operator}`,
    {
      params: {
        adminLevel1 : data.adminLevel1,
        adminLevel2: data.adminLevel2,
        adminLevel3: data.adminLevel3,
        action: data.action,
        quad: data.quad,
        msRank: data.rank
      },
      hideLoader: true
    }
  );
  return response.data;
};

export const getOperatorMSTableTooltipData = async (
  data,
) => {
  const response = await axiosInstance.get(
    `${baseUrl}/operator/pie-chart/${data.country}`,
    {
      params: {
        adminLevel1 : data.adminLevel1,
        adminLevel2: data.adminLevel2,
        adminLevel3: data.adminLevel3,
        quarter: data.quarter,
        connectionType: data.connectionType,
        lvl: data.borderLvl
      },
    }
  );
  return response.data;
};

export const getTopMSTooltipData = async (
  { country, quarter, ct, adm1,adm2,adm3,borderLvl, at }
) => { const response = await axiosMapInstance.get(
    `${baseUrl}/operator/polygon/tool-tip/${country}`,
    {
      params: {
        connectionType: ct,
        quarter: quarter,
        adminLevel1:adm1,
        adminLevel2:adm2,
        adminLevel3:adm3,
        lvl: borderLvl,
        aggrType: at
      },
    },
    { clearCacheEntry: true }
  );
  return response.data;
};

export const getOperatorMarketShareTrendsData = async (
  data,
) => {
  const response = await axiosMapInstance.post(
    `${baseUrl}/operator/trend/${data.country}/${data.type}`,
    {
        connectionType: data.connectionType,
        operator: data.operator,
        adminLevel1 : data.adminLevel1,
        adminLevel2: data.adminLevel2,
        adminLevel3: data.adminLevel3,
        start: data.start,
        end: data.end,
        lvl: data.borderLvl
      },
      { hideLoader: true }
  );
  return response.data;
};

export const getOperatorMSGeohashData = async (
  data,
  perPage,
  page = 1,
) => {
  const response = await axiosMapInstance.get(
    `${baseUrl}/operator/geohash/${data.country}`,
    {
      params: {
        adminLevel1: data.adminLevel1,
        adminLevel2: data.adminLevel2,
        adminLevel3: data.adminLevel3,
        quarter: data.quarter,
        connectionType: data.connectionType,
        operator: data.operator,
        limit: perPage,
        page: page,
        action: data.action,
        quad: data.quad,
        sortBy: data.sortBy || "adminLevel1", 
        sortOrder: data.sortOrder || "asc"
      },
      hideLoader: true
    }
  );
  return response.data;
};

export const getQuadCounts = async (data) => {
  const response = await axiosMapInstance.get(
    `${baseUrl}/operator/quad/count/${data.country}`,
    {
      params: {
        adminLevel1 : data.adminLevel1,
        adminLevel2: data.adminLevel2,
        adminLevel3: data.adminLevel3,
        quarter: data.quarter,
        op: data.op,
        ct: data.ct,
        action: data.action,
        admLvl: data.admLvl,
        rank: data.rank,
        msRangeFrom: data.msRangeFrom,
        msRangeTo: data.msRangeTo
      },
      hideLoader: true
    }
  );
  const formattedData = JSON.parse(JSON.stringify(response.data), (key, value) => 
    typeof value === 'number' ? value.toLocaleString() : value
  );

  return formattedData;
};

export const getNationAvailabilityData = async (
  data,
) => {
  const response = await axiosMapInstance.get(
    `${baseUrl}/operator/availability/${data.country}`,
    {
      params:{
        quarter:data.quarter,
        ct: data.connectionType,
        op: data.operator,
        adminLevel1 : data.adminLevel1,
        adminLevel2: data.adminLevel2,
        adminLevel3: data.adminLevel3,
        admLvl: data.borderLvl
      },
      hideLoader: true 
    }
  );
  return response.data;
};

// get min and max for MS Operator (Data Received, Data Transmit and Data Transceived)
export const fetchMinMaxMSOp = async (data)=> {
  const params = {
    quarter: data.quarter,
    ct: data.ct,
    dt: data.dt,
    msType: data.msType,
    op: data.op,
    lvl: data.lvl
  }
  const response = await axiosMapInstance.get(
    `${baseUrl}/operator/legend/minMax${data.country}`,
    {
      params,
      hideLoader: true
    }
  );
  return response.data;
};
